<template>
    <div>
        <audio ref="notification" controls style="display: none;">
            <source src="https://firebasestorage.googleapis.com/v0/b/onme-c1a37.appspot.com/o/assets%2Fnotification.mp3?alt=media">
            Your browser does not support the audio element.
        </audio>
        <md-app md-mode="fixed">
            <md-app-toolbar class="toolbar md-primary" v-if="loaded" :class="{'md-accent toolbar--inactive' : paused}">
                <img v-if="location.picture" class="logo logo--bar" :src="location.picture" alt="location">
                <span v-if="!location.picture">{{location.name}}</span>

                <md-button class="tab" :class="{'tab--active' : this.$router.currentRoute.name === 'dashboard'}"
                           @click="goToPage('dashboard')">
                    <span>Bestellungen</span>
                    <span class="dashboard__open-orders-badge"
                          :class="{'dashboard__open-orders-badge--paused': paused}">{{openOrders}}</span>
                </md-button>

                <md-button class="tab" :class="{'tab--active' : $router.currentRoute.name === 'history'}"
                           @click="goToPage('history')">
                    <span> Verlauf</span>
                </md-button>

                <md-button class="tab" :class="{'tab--active' : $router.currentRoute.name === 'products'}"
                           @click="goToPage('products')">
                    <span> Katalog</span>
                </md-button>


                <div class="search" v-if="$router.currentRoute.name === 'dashboard'" @click="resetSearch()">
                    <md-field>
                        <span class="md-prefix">#</span>
                        <md-input v-model="searchTerm"></md-input>
                        <md-icon v-if="searchTerm.length > 0">close</md-icon>
                    </md-field>
                </div>


                <div class="md-toolbar-section-end">

                    <div class="toolbar__tips" v-if="location.tips[0].sum_tips">
                        <div class="toolbar__tips-inner md-body-1">{{location.tips[0].sum_tips}}</div>
                    </div>

                    <md-switch v-model="pickUp" class="md-primary">Abholen</md-switch>

                    <md-switch v-model="tableService" class="md-primary">Bringen</md-switch>

                    <md-button class="md-icon-button" @click="toggleNotification">
                        <md-icon v-if="notification">alarm_on</md-icon>
                        <md-icon v-if="!notification">alarm_off</md-icon>
                    </md-button>
                    <md-button class="md-icon-button" @click="exit">
                        <md-icon>exit_to_app</md-icon>
                    </md-button>
                </div>
            </md-app-toolbar>

            <slot></slot>
        </md-app>

        <snackbar></snackbar>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import store from 'store'
    import Snackbar from './Snackbar'

    export default {
        name: "Layout",
        components: {
            Snackbar
        },
        data() {
            return {
                notification: false,
                searchTerm: '',
                tableService: null,
                pickUp: null
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('dashboard', [
                'loaded',
                'location'
            ]),
            paused: function () {
                return (!this.tableService && !this.pickUp);
            },
            openOrders: function () {
                return this.location.orders.filter(order => (!order.picked_up && !order.canceled && order.payment_transaction_id)).length
            }
        },
        watch: {
            searchTerm: function (val) {
                this.updateFilterNumber(val)
            },
            tableService: function (newVal, oldVal) {
                if (oldVal !== null) {
                    this.updateTableService(newVal);
                }
            },
            pickUp: function (newVal, oldVal) {
                if (oldVal !== null) {
                    this.updatePickUp(newVal);
                }

            }
        },
        methods: {
            ...mapActions('auth', [
                'logout'
            ]),
            ...mapActions('dashboard', [
                'loadLocation',
                'updateTableService',
                'updatePickUp',
                'updateFilterNumber'
            ]),
            exit: async function () {
                await this.logout(this.location.id);
                store.remove('user')
                this.$router.push('/login')
            },
            goToPage: function (name) {
                this.$router.push({name: name})
            },
            toggleNotification() {
                this.notification = !this.notification;

                if (this.notification) {
                    this.playNotification();
                }
            },
            playNotification() {
                this.$refs.notification.play();
            },
            resetSearch() {
                if (this.searchTerm.length > 0) {
                    this.searchTerm = ''
                }
            }
        },
        async mounted() {
            this.$material.locale = this.locale

            this.loadLocation(this.user.locationId).then(function () {
                this.tableService = this.location.table_service;
                this.pickUp = this.location.pick_up;
                this.$refs.notification.load();
                const database = window.firebase.database();
                database.ref("ping/location-" + this.user.locationId).on('child_changed', async function () {
                    await this.loadLocation(this.user.locationId)
                    if (this.notification) {
                        this.playNotification()
                    }
                }.bind(this));
            }.bind(this), function (error) {
                if (error.response.status == 401) {
                    store.remove('user')
                    this.$router.push('/login')
                }
            }.bind(this))


        }
    }
</script>
